export function isEarlyAccess(endsOn, now = new Date()) {
    if (!endsOn) {
        return true;
    }
    const endsAfter = new Date(`${endsOn}T00:00:00`);
    endsAfter.setDate(endsAfter.getDate() + 1);
    return now.getTime() < endsAfter.getTime();
}
//# sourceMappingURL=earlyAccess.js.map